import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import agLogo from 'assets/img/a_adriagate.svg';
import slogan from 'assets/img/slogan.svg';
import { Paragraph } from 'common/components';
import { Button } from 'components/common';
import { Flex } from 'components/styled/Flex';
import { fontFamily as fontFamilyAg } from 'services/theme/Adriagate/fontFamily';
import { useTheme } from 'styled-components';

export const Welcome = ({
  setOpenRegisterForm,
}: {
  setOpenRegisterForm: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { colors } = useTheme();

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      height="100vh"
      style={{ justifyContent: 'stretch' }}
    >
      <Flex width="100%" margin="2.5rem 0 0 4rem" style={{ maxHeight: '3rem' }}>
        <img src={slogan} alt="Slogan" />
      </Flex>
      <Flex
        justifyContent="center"
        style={{
          height: '100%',
          minHeight: '220px',
          maxHeight: '365px',
        }}
      >
        <img src={agLogo} alt="Adriagate" />
      </Flex>
      <Flex
        maxWidth="22rem"
        flexDirection="column"
        alignItems="center"
        backgroundColor="white"
        padding="1.5rem 1rem"
        margin="0.5rem 2rem 1rem 2rem"
        borderRadius="1.125rem"
      >
        <Flex flexDirection="column" gap="0.75rem">
          <Paragraph
            fontSize="1.25rem"
            fontFamily="Baloo-Paaji"
            fontWeight="700"
            lineHeight="1.625rem"
            letterSpacing="0.00625rem"
            margin="0"
            color="#222"
          >
            Registriraj se i postani dio Adriagate obitelji!
          </Paragraph>
          <Paragraph
            fontFamily={fontFamilyAg.regular}
            fontSize="0.8125rem"
            margin="0 0 1.5rem"
            color={colors.black_100}
          >
            Rješenje za jednostavnije poslovanje iznajmljivača.
          </Paragraph>
        </Flex>
        <Button
          label="Start registration"
          color="orange"
          width="100%"
          onClick={() => setOpenRegisterForm(true)}
        />
      </Flex>
      <Paragraph
        fontFamily={fontFamilyAg.regular}
        fontSize="0.875rem"
        fontWeight="400"
        justifyContent="center"
        color="white"
      >
        {t('You already have an account?')}
        <Paragraph
          fontFamily={fontFamilyAg.semiBold}
          fontSize="0.875rem"
          color="white"
          lineHeight="1.5rem"
          letterSpacing="0.00625rem"
          textDecoration="underline"
          onClick={() => navigate('/login')}
          cursor="pointer"
        >
          {t('Login here')}
        </Paragraph>
      </Paragraph>
    </Flex>
  );
};
